import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Package } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { RARITY, celebrate } from "@/lib/daily";
import { MascotTip, cheer } from "@/components/Mascot";

export default function ChestReveal({ rarity, onClose, refresh }) {
  const [res, setRes] = useState(null);
  const c = RARITY[rarity] || RARITY.common;

  useEffect(() => {
    if (!rarity) return setRes(null);
    let live = true;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.post("/daily/chest/open", { rarity });
        if (!live) return;
        setRes(data);
        celebrate(data.quests_done);
        refresh();
      } catch (e) { toast.error(errMsg(e)); onClose(); }
    }, 900);
    return () => { live = false; clearTimeout(t); };
  }, [rarity, onClose, refresh]);

  return (
    <Dialog open={!!rarity} onOpenChange={(o) => !o && res && onClose()}>
      <DialogContent data-testid="chest-reveal-dialog" className={`glass max-w-sm text-center ${res ? "" : "[&>button]:hidden"}`}>
        <DialogTitle className="font-display text-3xl" style={{ color: c.color }}>{c.label} chest</DialogTitle>
        <DialogDescription className="sr-only">Opening your chest</DialogDescription>
        <div className="relative h-40 grid place-items-center">
          <div className="absolute w-32 h-32 rounded-full blur-2xl opacity-60" style={{ background: c.color }} />
          <Package data-testid="chest-reveal-icon" className={`relative w-24 h-24 ${res ? "chest-pop" : "chest-shake"}`} style={{ color: c.color }} />
        </div>
        {res ? (
          <div className="space-y-4 rise">
            <p data-testid="chest-reveal-prizes" className="text-lg text-white">You found {res.prizes.join(", ")}</p>
            <MascotTip testid="chest-mascot-cheer" className="justify-center text-left">{cheer(res.rarity)}</MascotTip>
            <button data-testid="chest-reveal-close" onClick={onClose} className="ember-btn w-full py-3 rounded-lg text-sm">NICE</button>
          </div>
        ) : <p className="text-sm text-slate-400 font-mono-game">OPENING…</p>}
      </DialogContent>
    </Dialog>
  );
}
